export const AUTH = '/auth';
export const REGISTRATION = '/auth?tab=1';
export const RGS_AGENT_REGISTRATON = '/auth?tab=1&rgs-agent=true';
export const PASSWORD_RECOVERY = '/password-recovery';
export const AGENT_NOT_FOUND = '/agent-not-found';
export const MAIN = '/';
export const ACTS = '/acts';
export const SALES = '/sales';
export const ABOUT = '/about';
export const TERMINATION_CONTRACT = '/termination-contract';
export const SIGN_UNILATERALLY = '/sign-unilaterally';
export const UNILATERALLY_EXPIRED = '/unilaterally-expired';
export const LOGOUT = '/logout';
export const OTP = '/otp';
export const AGENT_CONTRACT = '/agent-contract';
export const NO_AGENT_CONTRACT = '/no-contract';
export const UNABLE_TO_CONCLUDE_CONTRACT = '/unable-to-conclude';
export const CONFIRM_CONTRACT = '/confirm-contract';
export const CREATE_SUBSCRIPTION = '/create-subscription';
export const SUBSCRIPTION_UNAVAILABLE = '/subscription-unavailable';
export const PROFILE = '/profile';
export const EDIT_PROFILE = `${PROFILE}/edit`;
export const SUBMIT_EDIT_PROFILE = `${PROFILE}/submit-edit`;
export const SUBMIT_EDIT_PROFILE_SUCCESS = `${PROFILE}/submit-edit-success`;
export const SUBMIT_EDIT_PROFILE_ERROR = `${PROFILE}/submit-edit-error`;
export const ERROR = '/error';
export const CONTACTS = '/contacts';
export const STATUSES_INFO = '/statuses-info';
export const PAYMENT_INFO = '/payment-info';
export const SIGN_ACT = '/sign-act';
export const ACCESS_SRG = '/access-srg';
export const STANDARDS = '/standards';
export const SMS_SENT = '/sms-sent';
export const ACCESSS_TO_RGS_SERVICES = '/access-to-rgs-services';

//Роуты флоу кандидата
export const CANDIDATE_AUTH = '/candidate-auth';
export const CANDIDATE_REGISTRATON = '/candidate-auth?tab=registration';
export const CANDIDATE_CREATE_PASSWORD =
  '/candidate-auth?tab=registration&step=0';
export const CANDIDATE_OTP = '/candidate-auth?tab=registration&step=1';
export const VERIFICATION = '/verification';
export const CANDIDATE_CONTRACT = '/candidate-contract';
export const WELCOME = '/welcome';

//Роуты флоу МВП агента
export const EXTENDED_PRODUCTS_CONTRACTS = '/extended-products-contracts';
export const SECURITY_QUESTIONNAIRE = '/security-questionnaire';
export const SECURITY_QUESTIONNAIRE_INFO = '/security-questionnaire/info';
export const SUBSCRIPTION_RESTRICTED = '/subscription-restricted';

export enum Routes {
  // service routes
  ANY = '*',

  MAIN = '/',

  // anonym routes
  ANONYM_SIGN_UP = '/sign-up',
  ANONYM_SIGN_IN = '/sign-in',
  ANONYM_PASSWORD_RECOVERY = '/password-recovery',

  // sign-up flow routes
  SIGN_UP_WELCOME = '/sign-up/welcome',
  SIGN_UP_VERIFY = '/verification',
  SIGN_UP_PERSONAL_DATA_CONFIRMATION = '/sign-up/personal-data-confirmation',
  SIGN_UP_EMPLOYMENT = '/sign-up/employment',
  SIGN_UP_QUESTIONNAIRE = '/sign-up/questionnaire',
  SIGN_UP_APPLICATION = '/sign-up/application',
  SIGN_UP_BANK_DETAILS = '/sign-up/bank-details',
  SIGN_UP_CONTRACT_SIGN = '/sign-up/contract-sign',
  SIGN_UP_SECURITY_CHECK = '/sign-up/security-check',
  ACCESSS_TO_RGS_SERVICES = '/access-to-rgs-services',
}
